import mixpanel from 'mixpanel-browser'

import EventBus from './eventbus.ts'

EventBus.on(EventBus.MIXPANEL_FILTER_ACTION, ({ detail: event }) => {
  mixpanel.track(EventBus.MIXPANEL_FILTER_ACTION, {
    'Filter Name': event.filter,
    'Filter Value': event.value,
  })
})

EventBus.on(EventBus.MIXPANEL_CTA_CLICKED, ({ detail: event }): void => {
  mixpanel.track(event.value, event.properties)
})

EventBus.on(EventBus.MIXPANEL_LIST_CLICKED, ({ detail: event }): void => {
  mixpanel.track('Clicked List', {
    'List Name': event.listName,
  })
})

EventBus.on(EventBus.MIXPANEL_HOMEPAGE_SCHOOLBREAK_CLICKED, ({ detail: event }): void => {
  mixpanel.track('Clicked Homepage School Break', {
    Value: event.value,
  })
})
